import {ErrorResponse} from '../../../core/data-source/error-response.record';
import {HttpCrudV2DataSource, HttpCrudV2Response} from '../../../core/data-source/http-crud-v2.data-source';
import {fromJson, toJson} from '../../../core/data-source/json.mapper';
import {withCsrfHeaders} from '../../../core/services/csrf';

export default class AppUserCrudDataSource<T> extends HttpCrudV2DataSource<T> {
    protected apiPath: string = '/ui-api/application-users';

    async changePassword(record: T, id: string | number): Promise<HttpCrudV2Response<T>> {
        const response = await fetch(`${this.apiPath}/${id}/change-password`, {
            method: 'POST',
            headers: withCsrfHeaders('POST', {
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(toJson(record)),
            credentials: 'include'
        });
        switch (response.status) {
            case 204:
                return {
                    success: true
                };
            case 400:
                return {
                    success: false,
                    error: fromJson(ErrorResponse, await response.json())
                };

            case 404:
                return {
                    success: false,
                    error: fromJson(ErrorResponse, await response.json())
                };
        }
    }
}
